import { toast } from 'react-toastify';
import axios from 'axios';
import {
  DEPLOYMENT_SETTING_LIST_GITHUB_EXPORT_LIST_BEGIN,
  DEPLOYMENT_SETTING_LIST_GITHUB_EXPORT_LIST_SUCCESS,
  DEPLOYMENT_SETTING_LIST_GITHUB_EXPORT_LIST_FAILURE,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function listGithubExportList(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DEPLOYMENT_SETTING_LIST_GITHUB_EXPORT_LIST_BEGIN,
    });
    const header = builderSurfaceJsonContentHeader(args.projectId, true);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/code-export/github/`,
        header,
      );

      doRequest.then(
        (res) => {
          const { success, data } = res.data;
          if (success) {
            dispatch({
              type: DEPLOYMENT_SETTING_LIST_GITHUB_EXPORT_LIST_SUCCESS,
              data: data,
            });
            resolve(res);
          } else {
            const errMsg =
              (res && res.data && res.data.message) || 'Failed to fetch GitHub export list';
            dispatch({
              type: DEPLOYMENT_SETTING_LIST_GITHUB_EXPORT_LIST_FAILURE,
              data: { error: errMsg },
            });
            toast.error(`Failed: ${errMsg}`, {});
            reject(errMsg);
          }
        },
        (err) => {
          const errorMessage = err.message || 'Error fetching GitHub export list';
          dispatch({
            type: DEPLOYMENT_SETTING_LIST_GITHUB_EXPORT_LIST_FAILURE,
            data: { error: errorMessage },
          });
          toast.error(`Error: ${errorMessage}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Reducer to handle actions
export function reducer(state, action) {
  switch (action.type) {
    case DEPLOYMENT_SETTING_LIST_GITHUB_EXPORT_LIST_BEGIN:
      return {
        ...state,
        listGithubExportRequestPending: true,
        listGithubExportRequestError: null,
      };

    case DEPLOYMENT_SETTING_LIST_GITHUB_EXPORT_LIST_SUCCESS:
      return {
        ...state,
        listGithubExportRequestPending: false,
        listGithubExportRequestError: null,
        githubExportList: action.data,
      };

    case DEPLOYMENT_SETTING_LIST_GITHUB_EXPORT_LIST_FAILURE:
      return {
        ...state,
        listGithubExportRequestPending: false,
        listGithubExportRequestError: action.data.error,
      };

    default:
      return state;
  }
}
